import React, { useEffect } from 'react';

import amplitude from 'amplitude-js';
import { sendGtEvent } from 'apps/auth/analytics/analytics';
import { sendBrazeEvent } from 'apps/auth/analytics/braze';
import { DangerouslyHtml } from 'apps/auth/components/common/DangerouslyHtml/DangerouslyHtml';
import { InfoPage } from 'apps/auth/components/common/Layout/InfoPage/InfoPage';
import { getRecipientTypeParam, providerCategories } from 'apps/auth/components/utils/AmplitudeUtils';
import { TRANSFER_CONFIRMATION_SHOWN } from 'apps/auth/constants/amplitude/AmplitudeEvents';
import {
    PAYMENT_COUNTRY,
    PAYMENT_CURRENCY,
    PAYMENT_FLOW,
    PAYMENT_METHOD_AMPLITUDE,
    PAYOUT_COUNTRY,
    PAYOUT_CURRENCY,
    PAYOUT_METHOD,
    RECIPIENT_TYPE,
    TRANSFER_ID,
} from 'apps/auth/constants/amplitude/AmplitudeParamName';
import { BR_SEND_SUCCESS } from 'apps/auth/constants/braze/brazeEvents';
import {
    BR_AMOUNT_SEND_CURRENCY,
    BR_PAYSEND_ID,
    BR_RECEIVING_COUNTRY_CODE,
    BR_SEND_CURRENCY,
    BR_SENDING_COUNTRY_CODE,
    BR_TRX_ID,
} from 'apps/auth/constants/braze/brazeParams';
import { GT_SEND_SUCCESS } from 'apps/auth/constants/GoogleAnalyticsEvents';
import { GT_AMOUNT_SEND_CURRENCY, GT_SEND_CURRENCY, GT_TRX_ID, GT_USER_ID } from 'apps/auth/constants/GoogleAnalyticsParamNames';
import { AUTH_SEND_MAIN_LINK } from 'apps/auth/constants/UrlConstants';
import { timer } from 'apps/auth/helpers/utils';
import { useAuth, useExtra, usePageMessages } from 'apps/auth/hooks/selectors';

const Pending = (props) => {
    const { ballId } = useAuth();
    const { headerTitle, statusText, statusDoneTitle } = usePageMessages();
    const { showButtonDone, cheque, statusBean } = useExtra();
    const fromCategory = cheque?.providerFromCategory?.toString();
    const toCategory = cheque?.providerToCategory?.toString();
    const sendingMethod = providerCategories[fromCategory];
    const deliveryMethod = providerCategories[toCategory];
    const toCountry = cheque?.toCountry?.nameEn;
    const fromCountry = cheque?.fromCountry?.nameEn;

    let timerID = null;

    useEffect(() => {
        if (!showButtonDone) {
            timerID = timer(
                timerID,
                () => {
                    window.location.href = AUTH_SEND_MAIN_LINK;
                },
                400,
            );
            return () => clearTimeout(timerID);
        }
    }, []);

    useEffect(() => {
        const paymentParam = sessionStorage?.getItem(cheque?.paymentId);
        amplitude.getInstance().logEvent(TRANSFER_CONFIRMATION_SHOWN, {
            [PAYOUT_COUNTRY]: toCountry,
            [PAYMENT_COUNTRY]: fromCountry,
            [PAYOUT_CURRENCY]: cheque?.amountToCurrency,
            [PAYMENT_CURRENCY]: cheque?.amountFromCurrency,
            [PAYOUT_METHOD]: deliveryMethod,
            [PAYMENT_METHOD_AMPLITUDE]: sendingMethod,
            [TRANSFER_ID]: cheque?.paymentId,
            [PAYMENT_FLOW]: paymentParam,
            [RECIPIENT_TYPE]: getRecipientTypeParam(statusBean?.recipientType),
        });
        sendGtEvent(GT_SEND_SUCCESS, {
            [GT_USER_ID]: ballId,
            [GT_TRX_ID]: cheque?.paymentId,
            [GT_SEND_CURRENCY]: cheque?.amountFromCurrency,
            [GT_AMOUNT_SEND_CURRENCY]: cheque?.amountFrom,
        });
        sendBrazeEvent(BR_SEND_SUCCESS, {
            [BR_TRX_ID]: cheque?.paymentId,
            [BR_SEND_CURRENCY]: cheque?.amountFromCurrency,
            [BR_AMOUNT_SEND_CURRENCY]: cheque?.amountFrom,
            [BR_PAYSEND_ID]: ballId,
            [BR_SENDING_COUNTRY_CODE]: cheque?.fromCountryId,
            [BR_RECEIVING_COUNTRY_CODE]: cheque?.toCountryId,
        });
    }, []);

    return (
        <>
            <InfoPage
                animatedIconSuccess
                headerText={headerTitle}
                secondaryText={<DangerouslyHtml dangerouslyHtml={statusText} />}
                primaryButtonCaption={showButtonDone ? statusDoneTitle : null}
                primaryButtonType="link"
                primaryButtonOnClick={(e) => {
                    e?.preventDefault();
                    props.toggleSpinner(true);
                    window.location.href = AUTH_SEND_MAIN_LINK;
                }}
            />
        </>
    );
};

export default Pending;
